import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5879515c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "faq__title" }
const _hoisted_4 = {
  key: 0,
  class: "visibility bg-red-100 text-red-800 text-xs font-medium mr-2 px-0-5 py-0-5 rounded dark:bg-gray-700 dark:text-red-400 border border-red-400"
}
const _hoisted_5 = { class: "faq__created" }
const _hoisted_6 = ["data-tooltip"]
const _hoisted_7 = {
  key: 0,
  class: "faq__category"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kategori:", -1))
const _hoisted_9 = { class: "faq__views" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "faq cursor-pointer",
          onClick: ($event: any) => (_ctx.navigateToFaq($event, faq)),
          key: faq.id
        }, [
          _createElementVNode("p", _hoisted_3, [
            (faq.is_draft == '1')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Utkast"))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(faq.title), 1)
          ]),
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(" Opprettet "),
            _createElementVNode("span", {
              class: "tooltip tooltip--indicated",
              "data-tooltip": _ctx.getAbsoluteDate(faq.created_at)
            }, _toDisplayString(_ctx.getRelativeDate(faq.created_at)), 9, _hoisted_6),
            _createTextVNode(" av "),
            _createElementVNode("span", null, _toDisplayString(faq.created_by.firstname + " " +  faq.created_by.lastname), 1)
          ]),
          (faq.category)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(faq.category?.breadcrumbs), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_9, [
            _createVNode(_component_SvgIcon, {
              size: 24,
              type: "mdi",
              path: _ctx.eyeIcon
            }, null, 8, ["path"]),
            _createTextVNode(" " + _toDisplayString(faq.views), 1)
          ])
        ], 8, _hoisted_2))
      }), 128))
    ])
  ]))
}